import type { ReactNode } from "react";
import { GlobalStyles, useMediaQuery } from "@mui/material";
import { MotionConfig } from "motion/react";
import { useUserSettingsStore } from "@/features/preferences/user-settings.store";

export const WorkspaceMotion = ({ children }: { children: ReactNode }) => {
  const enabled = useUserSettingsStore((state) => state.settings.animationsEnabled);
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  return (
    <MotionConfig reducedMotion={enabled ? "user" : "always"}>
      {(!enabled || reducedMotion) && (
        <GlobalStyles
          styles={{
            "*, *::before, *::after": {
              animationDuration: "0.01ms !important",
              animationIterationCount: "1 !important",
              transitionDuration: "0.01ms !important",
              scrollBehavior: "auto !important",
            },
          }}
        />
      )}
      {children}
    </MotionConfig>
  );
};
